var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraf4Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "461px",
    height: "348px",
    viewBox: "0 0 461 348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graf-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("text", {
    id: "text-1",
    fontFamily: "Rubik-Bold, Rubik",
    fontSize: 333.5904,
    fontWeight: "bold",
    letterSpacing: 1.77914989,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 51.0329195,
    y: 333
  }, "?")), /*#__PURE__*/React.createElement("filter", {
    x: "-26.4%",
    y: "-11.5%",
    width: "152.7%",
    height: "127.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.917647059   0 0 0 0 0.917647059   0 0 0 0 0.988235294  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graf-4",
    transform: "translate(-44.000000, -46.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.645044,298.816423 C228.215015,286.938808 199.833333,289.333333 188.5,306 C171.5,331 132.5,358.170715 163.5,379.584084 C184.166667,393.859663 225.577143,397.116446 287.73143,389.354433 C293.382262,389.003381 297.181844,388.775497 299.130177,388.670779 C334.72221,386.757801 369.345485,386.985686 403,389.354433 C458.855322,393.285767 514.052309,386 503.52901,355.5 C496.513477,335.166667 467.832501,318.666667 417.486083,306 L273.645044,298.816423 Z",
    id: "Path-72",
    fill: "#EAEAFC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#F7D0BF",
    transform: "translate(273.645044, 161.762133) rotate(-8.000000) translate(-273.645044, -161.762133) ",
    points: "322.131061 141.092027 269.466539 166.96671 212.263264 166.96671 222.781385 179.865583 276.095705 182.43224 335.026824 161.762133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-65",
    fill: "#F7D0BF",
    points: "220.099384 327 218.998459 351.069395 203 359.009718 209.204931 368 232.922958 366.241473 244 347.5 240.563174 328.044787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.410216,244.631492 C262.831029,227.981375 233.104151,224.632598 224.229582,234.585163 C215.355014,244.537727 212.880353,276.202704 216.8056,329.580094 L242.475564,330 C247.646581,293.64689 251.304556,274.219103 253.449487,271.716639 C255.594418,269.214174 272.963184,278.256584 305.555784,298.843866 C309.31596,303.01655 311.934104,299.877816 313.410216,289.427667 C314.468546,281.935215 313.869469,272.020378 313.410216,259.442674 C313.289354,256.132583 313.289354,251.195523 313.410216,244.631492 Z",
    id: "Path-32",
    fill: "#34395D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.802177,122.132494 C324.665541,121.070701 312.556349,126.39074 307.474601,138.09261 C302.392853,149.79448 300.848919,162.448362 302.8428,176.054255 L307.474601,199.546081 L312.976046,289.561129 L389.071675,306 L394.075173,299.772577 L402,299.772577 C393.102497,284.846908 386.185032,266.754275 381.247604,245.494677 C376.310177,224.23508 371.519534,191.914886 366.875675,148.534097 L343.802177,122.132494 Z",
    id: "Path-35",
    fill: "#F7465F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-66",
    fill: "#F7D0BF",
    points: "361 346.240414 361 365.725787 403 369 366.14288 342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.318468,299.207849 C369.187534,299.636508 352.894885,297.802925 345.440519,293.707102 C337.986154,289.611278 325.761911,288.188401 308.767793,289.438468 L236.518176,335.632624 C230.043853,340.351237 227.679332,346.066314 229.424613,352.777853 C231.169895,359.489393 232.52025,363.731095 233.47568,365.50296 C228.842853,365.50296 225.436198,365.50296 223.255715,365.50296 C219.98499,365.50296 214.373239,365.50296 210.880998,365.50296 C208.552837,365.50296 206.386898,363.57119 204.383181,359.70765 C189.513213,361.526645 180.851876,363.458415 178.399169,365.50296 C175.946462,367.547505 174.146739,370.046519 173,373 L361.804211,371.043089 L361.804211,348.672492 C361.767291,346.59316 362.883265,345.553494 365.15213,345.553494 C367.420996,345.553494 380.530745,354.702329 404.481376,373 L424,373 L370.097654,331 L356.497607,335.632624 C371.938611,327.371119 381.305606,321.44564 384.598593,317.856189 C387.89158,314.266738 391.131539,308.050625 394.318468,299.207849 Z",
    id: "Path-33",
    fill: "#34395D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "?",
    transform: "translate(152.500000, 218.500000) rotate(16.000000) translate(-152.500000, -218.500000) ",
    fill: "#FFFFFF",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#text-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.599147,165 L282.976365,202.50407 L213.332772,202.50407 L200.610246,190.962202 C200.16848,190.561433 199.48547,190.594667 199.0847,191.036432 C198.904441,191.235131 198.804588,191.493809 198.804588,191.76209 L198.804588,196.553681 C192.923258,193.212864 188.430906,192.028304 185.327531,193 C182.224156,193.971696 182.224156,197.744125 185.327531,204.317286 L208.486622,211.747204 C260.496665,217.915735 287.672661,221 290.014612,221 C292.356562,221 311.685025,210.44137 348,189.324111 L325.599147,165 Z",
    id: "Path-36",
    fill: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.308853,56.2857669 L295.486083,84.0283092 L299.942171,85.5354372 C302.302029,98.4174133 305.579349,104.858401 309.774134,104.858401 C310.98465,104.858401 315.758981,103.737214 316.552949,105.815092 C317.857853,109.230134 317.292033,121.387025 314.855488,142.285767 L344.486083,130.934899 L341.344444,74.3429922 L304.308853,56.2857669 Z",
    id: "Path-38",
    fill: "#F7D0BF",
    transform: "translate(319.986083, 99.285767) rotate(-11.000000) translate(-319.986083, -99.285767) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.730433,59.1435407 C301.779231,69.4244621 299.968671,74.5649229 299.298752,74.5649229 C298.293873,74.5649229 293.590365,68.5149756 294.637041,63.8292581 C295.334825,60.7054465 298.171687,57.5821012 303.147626,54.459222 C312.09486,46.5261393 322.176416,43.2326161 333.392293,44.5786525 C350.216108,46.5977072 370.025215,52.0001924 368.706443,83.65606 C367.387672,115.311928 382.258565,132.459278 379.024662,149.022165 C375.790759,165.585052 370.505935,174.659628 368.192818,176.128985 C365.879702,177.598342 351.145849,168.562036 349.634669,156.476382 C348.123489,144.390728 351.79379,143.209507 348.602404,139.324558 C345.411018,135.439609 337.498882,127.995612 337.498882,123.416897 C337.498882,118.838182 340.790367,112.415952 337.498882,109.717818 C334.207398,107.019684 324.413693,104.24462 323.481845,94.1213722 C322.549998,83.9981245 320.859751,64.9461374 318.661799,63.8292581 C317.196497,63.084672 312.552709,61.5227662 304.730433,59.1435407 Z",
    id: "Path-62",
    fill: "#34395D",
    transform: "translate(336.986083, 110.285767) rotate(-11.000000) translate(-336.986083, -110.285767) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraf4Small);
export default __webpack_public_path__ + "static/media/graf-4-small.15b07a8d7343e658b649a6c2c34157a2.svg";
export { ForwardRef as ReactComponent };